import { render, staticRenderFns } from "./ClassificationCard.vue?vue&type=template&id=11a13e15&"
import script from "./ClassificationCard.vue?vue&type=script&lang=js&"
export * from "./ClassificationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports